import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './empty_state.module.scss';

type Props = {
  logo: string;
  title: string;
  customClass?: string;
};

export const EmptyState: FC<Props> = ({
  customClass = '',
  logo,
  title,
  children,
}) => {
  return (
    <div className={classNames(customClass, styles.container)}>
      <img className={styles.logo} src={logo} alt="logo" />
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div>{children}</div>
      </div>
    </div>
  );
};
